import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Zone add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminProductionWorkflowForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminProductionWorkflowFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminProductionWorkflowForm}.
 *
 * @type {ngController}
 */
export class tmrAdminProductionWorkflowFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    $timeout,
    Place
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { $timeout, Place })
  }

  $onInit() {
    super.$onInit()
    this.treeOptions = {
      dropped: () => this.reorderPhases(),
    }
    // Default phase sort.
    this.resource.phases.sort((a, b) => a.phaseOrder - b.phaseOrder)
    // Add an empty phase for user convenience.
    if (!this.resource.phases.length) this.addPhase()
  }

  /** Query to get workers (places) for md-autocomplete */
  getWorkers(value) {
    return this.Place.search({ value }).$promise
  }

  addPhase() {
    let phaseOrder = this.resource.phases.length
      ? this.resource.phases[this.resource.phases.length - 1].phaseOrder + 1
      : 0
    this.resource.phases.push({ phaseOrder })
  }

  removePhase(idx) {
    this.resource.phases.splice(idx, 1)
    if (!this.resource.phases.length) this.addPhase()
  }

  reorderPhases() {
    // Timeout because ui-tree updates the model after this event.
    this.$timeout(() =>
      this.resource.phases.forEach((phase, idx) => (phase.phaseOrder = idx))
    )
  }
}
